<template>
  <div class="wrap">
    <a-layout>
      <a-layout-header class="header">
        <div class="header-left">
          <div
            class="logo"
            :style="{ 'background-image': 'url(' + logo + ')' }"
          />
          <a-menu
            theme="dark"
            mode="horizontal"
            class="menu-line"
            :selectedKeys="[selectedKey]"
          >
            <a-menu-item
              v-for="m in menu"
              :key="m.name"
              @click="gotoSomewhere(m)"
            >
              {{ m.meta.menu }}
            </a-menu-item>
          </a-menu>
        </div>
        <div class="header-right">
          <a-icon
            class="menu-icon"
            :class="{ 'menu-icon-expand': menuIsExpand }"
            @click="toggoleMenu"
            type="menu-fold"
          />
        </div>
      </a-layout-header>
      <a-list
        itemLayout="horizontal"
        :dataSource="menu"
        class="expand-menu-hide"
        :class="{ 'expand-menu': menuIsExpand }"
        v-if="menuIsExpandDom"
      >
        <a-list-item slot="renderItem" slot-scope="m, index">
          <a-list-item-meta :key="index" @click="gotoSomewhere(m)">
            <a slot="title">{{ m.meta.menu }}</a>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-layout>
  </div>
</template>

<script>
import logo from "@/assets/logo-white.png";

export default {
  name: "Header",
  props: {
    selectedKey: {
      type: String,
      default: ""
    },
    menu: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      logo,
      menuIsExpand: false,
      menuIsExpandDom: false,
    };
  },
  methods: {
    gotoSomewhere(e) {
      if (e.name !== this.$route.name) {
        this.$router.push({
          name: e.name
        });
      }
      this.removeExpandMenu();
    },
    toggoleMenu() {
      if (this.menuIsExpand && this.menuIsExpandDom) {
        this.removeExpandMenu();
      } else if (
        this.menuIsExpand === false &&
        this.menuIsExpandDom === false
      ) {
        this.addExpandMenu();
      }
    },
    removeExpandMenu() {
      this.menuIsExpand = false;
      setTimeout(() => {
        this.menuIsExpandDom = false;
      }, 1200);
    },
    addExpandMenu() {
      this.menuIsExpandDom = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.menuIsExpand = true;
        }, 0);
      });
    },
  }
};
</script>
<style lang="css" scoped>
.wrap {
  width: 100%;
  font-size: 12px;
}
.wrap .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wrap .header .header-left,
.wrap .header .header-right {
  display: flex;
  align-items: center;
}
.wrap .header .logo {
  width: 112px;
  height: 48px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  margin-right: 2rem;
}
.wrap .header .ant-menu-item-selected {
  background-color: #00284e;
}
.wrap .header .menu-icon {
  display: none;
}
.wrap .header .user-icon {
  display: block;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.wrap .expand-menu-hide {
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: -1;
  transition: all 1000ms;
  background-color: #001f3b;
}
.wrap .expand-menu-hide .ant-list-item-meta-title {
  text-indent: 1rem;
}
.wrap .expand-menu-hide .ant-list-item-meta-title a {
  color: #ffffff;
}
.login-form {
  width: 90%;
  min-width: 250px;
  margin: 0 auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
.login-form .ant-row.ant-form-item {
  width: 90%;
  min-width: 200px;
}
@media screen and (max-width: 777px) {
  .wrap .header {
    padding: 0 1rem;
  }
  .wrap .header .menu-line {
    display: none;
  }
  .wrap .header .user-icon {
    visibility: hidden;
  }
  .wrap .header .menu-icon {
    display: block;
    font-size: 1.5rem;
    color: #ffffff;
    cursor: pointer;
    transition: all 300ms;
  }
  .wrap .header .menu-icon-expand {
    transform: rotate(-90deg);
  }
  .wrap .expand-menu {
    width: 100%;
    top: 64px;
    height: auto;
    opacity: 1;
    z-index: 120;
  }
  .wrap .user-icon-expand {
    display: block;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
  }
}

</style>
